import { cn } from '@repo/tailwind-config/tailwind.functions'
import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import React from 'react'

import { ExclamationMarkIcon } from '../../icons'
import Typography from './typography'

export type WarningBadgeProps = {
  className?: string
  text: string | React.ReactNode
}

const WarningBadge: React.FC<WarningBadgeProps> = ({ className, text }) => {
  return (
    <div
      className={cn('flex gap-1 items-center w-full bg-red-light px-4 py-3 rounded', className)}
    >
      <ExclamationMarkIcon filled={false} color={tailwindColors.red.DEFAULT} />
      <Typography as="div" variant="label-semibold" color={tailwindColors.red.DEFAULT}>
        {text}
      </Typography>
    </div>
  )
}

export default WarningBadge
